import { render, staticRenderFns } from "./inOilRecord.vue?vue&type=template&id=c27127f4&scoped=true&"
import script from "./inOilRecord.vue?vue&type=script&lang=js&"
export * from "./inOilRecord.vue?vue&type=script&lang=js&"
import style0 from "./inOilRecord.vue?vue&type=style&index=0&id=c27127f4&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27127f4",
  null
  
)

component.options.__file = "inOilRecord.vue"
export default component.exports